import {
	Dimensions,
	ViewStyle,
	Platform
} from 'react-native';
import {
	BorderConfig,
	ColorTokens,
	PaddingProps,
	PositionConfig,
	ShadowTypeTokens,
	StackAlignContent,
	StackFlexWrap,
	StackHeight,
	StackPositionType,
	StackSelfContent,
	StackWidth,
} from '@voltmoney/schema';
import ThemeProvider from '@voltmoney/theme';

const theme = ThemeProvider.getTheme();

export enum SCREEN_SIZE {
	/**
	 * Screen Width <576px
	 */
	X_SMALL = 'extra_small',

	/**
	 * Screen Width >=576px
	 */
	SMALL = 'small',

	/**
	 * Screen Width >=768px
	 */
	MEDIUM = 'medium',

	/**
	 * Screen Width >=992px
	 */
	LARGE = 'large',

	/**
	 * Screen Width >=1200px
	 */
	X_LARGE = 'extra_large',
}

export const getScreenType = (
	screenWidth?: number,
): SCREEN_SIZE => {
	const screenWidthX =
		screenWidth || Dimensions.get('window').width;
	if (screenWidthX < 576)
		return SCREEN_SIZE.X_SMALL;
	if (screenWidthX < 768) return SCREEN_SIZE.SMALL;
	if (screenWidthX < 992)
		return SCREEN_SIZE.MEDIUM;
	if (screenWidthX < 1200)
		return SCREEN_SIZE.LARGE;
	if (screenWidthX >= 1200)
		return SCREEN_SIZE.X_LARGE;

	return SCREEN_SIZE.X_SMALL;
};
export const isMobile = (
	screenType: SCREEN_SIZE,
) =>
	screenType === SCREEN_SIZE.X_SMALL ||
	screenType === SCREEN_SIZE.SMALL;



export const isMobileView = () => {
		const Breakpoint = 1024
		if (Platform.OS === 'web') {
			if (window?.outerWidth < Breakpoint) {
				return true
			} else {
				return false
			}
		}
		return true
}

export const isMobileViewApp = () => {
	const Breakpoint = 1024
	if (Platform.OS === 'web') {
		if (window?.innerWidth < Breakpoint) {
			return true
		} else {
			return false
		}
	}
	return true
}

export const isFontMobile = () => {
	if(Platform.OS !== "web") {
		return true;
	} else if (isMobileViewApp()){
		return true;
	} else {
		return false;
	}
}

export const checkWindowWidth = () => {
	if (Platform.OS === "web") {
		if(window?.outerWidth < 1024) {
			return 1;
		} else if (window?.outerWidth < 1300 && window?.outerWidth > 1024) {
			return 2
		} else {
			return 3;
		}
	}
}



const PLATFORM_PADDING: number = 16 * 2;
const DESKTOP_WIDTH: number = 508;

export const UI_WINDOW_HEIGHT: (
	screenType: SCREEN_SIZE,
) => number = (screenType: SCREEN_SIZE) =>
	isMobile(screenType)
		? PLATFORM_PADDING
		: 114 + PLATFORM_PADDING;

export const _getUiWindow: (
	screenSize: number,
) => number = (screenSize) =>
	isMobile(getScreenType(screenSize))
		? screenSize - PLATFORM_PADDING
		: DESKTOP_WIDTH - PLATFORM_PADDING;

export const applyMargin = (
	padding?: PaddingProps,
) => {
	let style = <ViewStyle>{};
	if (!padding) return style;
	if (padding.left) {
		style = {
			...style,
			marginLeft: theme.space[padding.left],
		};
	}
	if (padding.right) {
		style = {
			...style,
			marginRight: theme.space[padding.right],
		};
	}
	if (padding.top) {
		style = {
			...style,
			marginTop: theme.space[padding.top],
		};
	}
	if (padding.bottom) {
		style = {
			...style,
			marginBottom: theme.space[padding.bottom],
		};
	}
	if (padding.horizontal) {
		delete style.marginLeft;
		delete style.marginRight;
		style = {
			...style,
			marginHorizontal:
				theme.space[padding.horizontal],
		};
	}
	if (padding.vertical) {
		delete style.marginTop;
		delete style.marginBottom;
		style = {
			...style,
			marginVertical: theme.space[padding.vertical],
		};
	}
	if (padding.all) {
		delete style.marginLeft;
		delete style.marginRight;
		delete style.marginTop;
		delete style.marginBottom;
		style = {
			...style,
			margin: theme.space[padding.all],
		};
	}
	return style;
};
export const applyPadding = (
	padding?: PaddingProps,
) => {
	let style = <ViewStyle>{};
	if (!padding) return style;
	if (padding.left) {
		style = {
			...style,
			paddingLeft: theme.space[padding.left],
		};
	}
	if (padding.right) {
		style = {
			...style,
			paddingRight: theme.space[padding.right],
		};
	}
	if (padding.top) {
		style = {
			...style,
			paddingTop: theme.space[padding.top],
		};
	}
	if (padding.bottom) {
		style = {
			...style,
			paddingBottom: theme.space[padding.bottom],
		};
	}
	if (padding.horizontal) {
		delete style.marginLeft;
		delete style.marginRight;
		style = {
			...style,
			paddingHorizontal:
				theme.space[padding.horizontal],
		};
	}
	if (padding.vertical) {
		delete style.marginTop;
		delete style.marginBottom;
		style = {
			...style,
			marginVertical: theme.space[padding.vertical],
		};
	}
	if (padding.all) {
		delete style.marginLeft;
		delete style.marginRight;
		delete style.marginBottom;
		delete style.marginTop;
		delete style.marginBottom;
		style = {
			padding: theme.space[padding.all],
		};
	}
	return style;
};
export const applyFlexWrap = (
	FlexWarp?: StackFlexWrap,
) => {
	let style = <ViewStyle>{};
	if (!FlexWarp) {
		return style;
	} else {
		style = {
			flexWrap: FlexWarp,
		};
	}
	return style;
};
export const applyFlex = (flex?: number) => {
	let style = <ViewStyle>{};
	if (!flex) {
		return style;
	} else {
		style = {
			flex: flex,
		};
	}
	return style;
};
export const applyAlignSelf = (
	alignSelf?: StackSelfContent,
) => {
	let style = <ViewStyle>{};
	if (!alignSelf) {
		return style;
	} else {
		style = {
			alignSelf: alignSelf,
		};
	}
	return style;
};
export const applyAlignContent = (
	alignContent?: StackAlignContent,
) => {
	let style = <ViewStyle>{};
	if (!alignContent) {
		return style;
	} else {
		style = {
			// alignContent: alignContent
		};
	}
	return style;
};
export const applyPosition = (
	position?: StackPositionType,
	positionConfig?: PositionConfig,
) => {
	let style = <ViewStyle>{};
	if (!position) {
		return style;
	} else {
		if (positionConfig.top) {
			style = {
				...style,
				top: theme.space[positionConfig.top],
			};
		}
		if (positionConfig.left) {
			style = {
				...style,
				left: theme.space[positionConfig.left],
			};
		}
		if (positionConfig.right) {
			style = {
				...style,
				right: theme.space[positionConfig.right],
			};
		}
		if (positionConfig.bottom) {
			style = {
				...style,
				bottom: theme.space[positionConfig.bottom],
			};
		}
	}
	return style;
};
export const applyBorder = (
	borderConfig?: BorderConfig,
) => {
	let style = <ViewStyle>{};
	if (!borderConfig) {
		return style;
	} else {
		if (borderConfig.borderColor) {
			style = {
				...style,
				borderColor:
					theme.colors[borderConfig.borderColor],
			};
		}
		if (borderConfig.borderRadius) {
			style = {
				...style,
				borderRadius:
					theme.borderRadius[
						borderConfig.borderRadius
					],
			};
		}
		if (borderConfig.borderWidth) {
			if (borderConfig.borderWidth.top) {
				style = {
					...style,
					borderTopWidth:
						theme.space[borderConfig.borderWidth.top],
				};
			}
			if (borderConfig.borderWidth.bottom) {
				style = {
					...style,
					borderBottomWidth:
						theme.space[
							borderConfig.borderWidth.bottom
						],
				};
			}
			if (borderConfig.borderWidth.left) {
				style = {
					...style,
					borderLeftWidth:
						theme.space[borderConfig.borderWidth.left],
				};
			}
			if (borderConfig.borderWidth.right) {
				style = {
					...style,
					borderRightWidth:
						theme.space[borderConfig.borderWidth.right],
				};
			}
			if (borderConfig.borderWidth.all) {
				delete style.borderLeftWidth;
				delete style.borderTopWidth;
				delete style.borderBottomWidth;
				delete style.borderRightWidth;
				style = {
					...style,
					borderWidth:
						theme.space[borderConfig.borderWidth.all],
				};
			}
		}
	}
	return style;
};
export const applyZIndex = (zIndex?: number) => {
	let style = <ViewStyle>{};
	if (!zIndex) {
		return style;
	} else {
		style = {
			zIndex: zIndex,
		};
	}
	return style;
};
export const applyShadow = (
	shadowType?: ShadowTypeTokens,
) => {
	return theme.shadow[shadowType];
};
export const applyBgColor = (
	bgColor?: ColorTokens,
) => {
	return {
		backgroundColor: theme.colors[bgColor],
	};
};
export const applyWidth = (
	width: StackWidth,
	screenWidth: number,
) => {
	return width === StackWidth.FULL
		? {
				width: screenWidth,
		  }
		: width === StackWidth.MATCH_PARENT
		? {
				width: '100%',
		  }
		: {};
};
export const applyHeight = (
	height: StackHeight,
	screenHeight: number,
) => {
	return height === StackHeight.FULL
		? {
				height: screenHeight,
		  }
		: height === StackHeight.MATCH_PARENT
		? {
				height: '100%',
		  }
		: {};
};

export const addCommasToNumber = (
	num: number,
) => {
	return num
		.toString()
		.replace(
			/\B(?=(?:(\d\d)+(\d)(?!\d))+(?!\d))/g,
			',',
		);
};

export const priceInWords = (price) => {
	var sglDigit = [
			'Zero',
			'One',
			'Two',
			'Three',
			'Four',
			'Five',
			'Six',
			'Seven',
			'Eight',
			'Nine',
		],
		dblDigit = [
			'Ten',
			'Eleven',
			'Twelve',
			'Thirteen',
			'Fourteen',
			'Fifteen',
			'Sixteen',
			'Seventeen',
			'Eighteen',
			'Nineteen',
		],
		tensPlace = [
			'',
			'Ten',
			'Twenty',
			'Thirty',
			'Forty',
			'Fifty',
			'Sixty',
			'Seventy',
			'Eighty',
			'Ninety',
		],
		handle_tens = function (dgt, prevDgt) {
			return 0 == dgt
				? ''
				: ' ' +
						(1 == dgt
							? dblDigit[prevDgt]
							: tensPlace[dgt]);
		},
		handle_utlc = function (dgt, nxtDgt, denom) {
			return (
				(0 != dgt && 1 != nxtDgt
					? ' ' + sglDigit[dgt]
					: '') +
				(0 != nxtDgt || dgt > 0 ? ' ' + denom : '')
			);
		};

	var str = '',
		digitIdx = 0,
		digit = 0,
		nxtDigit = 0,
		words = [];
	if (((price += ''), isNaN(parseInt(price))))
		str = '';
	else if (
		parseInt(price) > 0 &&
		price.length <= 10
	) {
		for (
			digitIdx = price.length - 1;
			digitIdx >= 0;
			digitIdx--
		)
			switch (
				((digit = price[digitIdx] - 0),
				(nxtDigit =
					digitIdx > 0 ? price[digitIdx - 1] - 0 : 0),
				price.length - digitIdx - 1)
			) {
				case 0:
					words.push(handle_utlc(digit, nxtDigit, ''));
					break;
				case 1:
					words.push(
						handle_tens(digit, price[digitIdx + 1]),
					);
					break;
				case 2:
					words.push(
						0 != digit
							? ' ' +
									sglDigit[digit] +
									' Hundred' +
									(0 != price[digitIdx + 1] &&
									0 != price[digitIdx + 2]
										? ' and'
										: '')
							: '',
					);
					break;
				case 3:
					words.push(
						handle_utlc(digit, nxtDigit, 'Thousand'),
					);
					break;
				case 4:
					words.push(
						handle_tens(digit, price[digitIdx + 1]),
					);
					break;
				case 5:
					words.push(
						handle_utlc(digit, nxtDigit, 'Lakh'),
					);
					break;
				case 6:
					words.push(
						handle_tens(digit, price[digitIdx + 1]),
					);
					break;
				case 7:
					words.push(
						handle_utlc(digit, nxtDigit, 'Crore'),
					);
					break;
				case 8:
					words.push(
						handle_tens(digit, price[digitIdx + 1]),
					);
					break;
				case 9:
					words.push(
						0 != digit
							? ' ' +
									sglDigit[digit] +
									' Hundred' +
									(0 != price[digitIdx + 1] ||
									0 != price[digitIdx + 2]
										? ' and'
										: ' Crore')
							: '',
					);
			}
		str = words.reverse().join('');
	} else str = '';
	return str ? 'Rupees' + str : str;
};

export const priceInWordsContainsDecimal = (price) => {
	const roundPrice = Math.round(price * 100) / 100;
    const priceArray = price?.split('.');
	let integerPart = priceArray[0];
	let f1 = false;
	if(integerPart % 10 ==0) f1 =true;
	const decimalPart = priceArray[1];
	var sglDigit = [
			'Zero',
			'One',
			'Two',
			'Three',
			'Four',
			'Five',
			'Six',
			'Seven',
			'Eight',
			'Nine',
		],
		dblDigit = [
			'Ten',
			'Eleven',
			'Twelve',
			'Thirteen',
			'Fourteen',
			'Fifteen',
			'Sixteen',
			'Seventeen',
			'Eighteen',
			'Nineteen',
		],
		tensPlace = [
			'',
			'Ten',
			'Twenty',
			'Thirty',
			'Forty',
			'Fifty',
			'Sixty',
			'Seventy',
			'Eighty',
			'Ninety',
		],
		handle_tens = function (dgt, prevDgt) {
			return 0 == dgt
				? ''
				: ' ' +
						(1 == dgt
							? dblDigit[prevDgt]
							: tensPlace[dgt]);
		},
		handle_utlc = function (dgt, nxtDgt, denom) {
			return (
				(0 != dgt && 1 != nxtDgt
					? ' ' + sglDigit[dgt]
					: '') +
				(0 != nxtDgt || dgt > 0 ? ' ' + denom : '')
			);
		};

		let paiseWords = "";
		if(decimalPart!== undefined && decimalPart!==''){
			if(decimalPart.length === 1){
				paiseWords = ` ${sglDigit[decimalPart]}`
			}
			else if (decimalPart.length === 2){
				if(decimalPart[0]=='1' || decimalPart[1]=='0') paiseWords = handle_tens(decimalPart[0],decimalPart[1]);
				else paiseWords = handle_tens(decimalPart[0],decimalPart[1]) +" "+ sglDigit[decimalPart[1]];
			}
		}

	var str = '',
		digitIdx = 0,
		digit = 0,
		nxtDigit = 0,
		words = [];
	if (((integerPart += ''), isNaN(parseInt(integerPart))))
		str = '';
	else if (
		parseInt(integerPart) > 0 &&
		integerPart.length <= 10
	) {
		for (
			digitIdx = integerPart.length - 1;
			digitIdx >= 0;
			digitIdx--
		)
			switch (
				((digit = integerPart[digitIdx] - 0),
				(nxtDigit =
					digitIdx > 0 ? integerPart[digitIdx - 1] - 0 : 0),
				integerPart.length - digitIdx - 1)
			) {
				case 0:
					words.push(handle_utlc(digit, nxtDigit, ''));
					break;
				case 1:
					words.push(
						handle_tens(digit, integerPart[digitIdx + 1]),
					);
					break;
				case 2:
					words.push(
						0 != digit
							? ' ' +
									sglDigit[digit] +
									' Hundred' +
									(0 != integerPart[digitIdx + 1] &&
									0 != integerPart[digitIdx + 2]
										? ' and'
										: '')
							: '',
					);
					break;
				case 3:
					words.push(
						handle_utlc(digit, nxtDigit, 'Thousand'),
					);
					break;
				case 4:
					words.push(
						handle_tens(digit, integerPart[digitIdx + 1]),
					);
					break;
				case 5:
					words.push(
						handle_utlc(digit, nxtDigit, 'Lakh'),
					);
					break;
				case 6:
					words.push(
						handle_tens(digit, integerPart[digitIdx + 1]),
					);
					break;
				case 7:
					words.push(
						handle_utlc(digit, nxtDigit, 'Crore'),
					);
					break;
				case 8:
					words.push(
						handle_tens(digit, integerPart[digitIdx + 1]),
					);
					break;
				case 9:
					words.push(
						0 != digit
							? ' ' +
									sglDigit[digit] +
									' Hundred' +
									(0 != integerPart[digitIdx + 1] ||
									0 != integerPart[digitIdx + 2]
										? ' and'
										: ' Crore')
							: '',
					);
			}
		str = words.reverse().join('');
	} else str = '';
	let resultStr = "";
	if(str){
		if(paiseWords){
			if(f1) resultStr = parseInt(price) === 1 ? `${str} Rupee and${paiseWords} Paise` : `${str} Rupees and${paiseWords} Paise`
			else resultStr = parseInt(price) === 1 ? `${str}Rupee and${paiseWords} Paise` : `${str}Rupees and${paiseWords} Paise`
		}
		else resultStr = parseInt(price) === 1 ? `Rupee${str}` : `Rupees${str}`
	}
	else {
		if(paiseWords) resultStr = `${paiseWords} Paise`
	}
	return resultStr;
};


export const isCloseToBottom = ({layoutMeasurement, contentOffset, contentSize}) => {
	const paddingToBottom = 20;
	return layoutMeasurement.height + contentOffset.y >=
		contentSize.height - paddingToBottom;
};

export const hasScrollEndReached = ({layoutMeasurement, contentOffset, contentSize}) => {
	return layoutMeasurement.height + contentOffset.y >=
		contentSize.height;
};

export const convertTimeStampToFormattedTime = (timestamp) => {
	if(timestamp === null || timestamp === undefined) return "";
    const date = new Date(timestamp);

    const hours = date.getHours();
    const minutes = date.getMinutes();
    const ampm = hours >= 12 ? 'PM' : 'AM';

    // Convert hours to 12-hour format
    const formattedHours = hours % 12 || 12;

    const formattedDate = `${formattedHours}:${minutes < 10 ? '0' : ''}${minutes} ${ampm}, ${date.getDate()}-${date.toLocaleString('default', { month: 'short' })}`;
    return formattedDate;
}

export const convertTimeStampToFormattedDateAndTime = (timestamp) => {
    if (timestamp === null || timestamp === undefined) return "";
    const date = new Date(timestamp);

    const day = date.getDate();
    const monthAbbreviation = date.toLocaleString('default', { month: 'short' });
    const hours = date.getHours();
    const minutes = date.getMinutes();
    const ampm = hours >= 12 ? 'PM' : 'AM';

    // Convert hours to 12-hour format
    const formattedHours = hours % 12 || 12;

    // Use template literals to construct the formatted date
    const formattedDate = `${day} ${monthAbbreviation}, ${formattedHours < 10 ? '0' : ''}${formattedHours}:${minutes < 10 ? '0' : ''}${minutes} ${ampm}`;

    return formattedDate;
};

export const convertTimeStampToMonth = (timestamp) => {
    if (timestamp === null || timestamp === undefined) return "";
    const date = new Date(timestamp);

    const day = date.getDate();
    const monthAbbreviation = date.toLocaleString('default', { month: 'short' });
    const hours = date.getHours();
    const minutes = date.getMinutes();
    const ampm = hours >= 12 ? 'PM' : 'AM';

    // Convert hours to 12-hour format
    const formattedHours = hours % 12 || 12;

    // Use template literals to construct the formatted date
    const formattedDate = `${day} ${monthAbbreviation}`;

    return formattedDate;
};

export const addSuffix = (day) => {
	if (day >= 11 && day <= 13) {
		return 'th';
	}
	switch (day % 10) {
		case 1:
			return 'st';
		case 2:
			return 'nd';
		case 3:
			return 'rd';
		default:
			return 'th';
	}
};

export const getDateMonthYearFromEpoch = (epochNumber?: number) => {
	const newDateToPick = new Date(epochNumber)
	const displayDate = newDateToPick.getDate()
	const dateName = `${displayDate}${addSuffix(displayDate)}`
	const monthNames = ["Jan", "Feb", "Mar", "Apr", "May", "June",
		"July", "Aug", "Sept", "Oct", "Nov", "Dec"
	];
	const getMonthName = newDateToPick.getMonth()
	const currentYear = newDateToPick.getFullYear();
	return `${dateName} ${monthNames[getMonthName]}, ${currentYear}`

}

export const convertTimeStampToFormattedDateAndTimeAMPMLowerCase = (timestamp) => {
	if (timestamp === null || timestamp === undefined) return "";
	const date = new Date(timestamp);

	const day = date.getDate();
	const monthAbbreviation = date.toLocaleString('default', { month: 'short' });
	const hours = date.getHours();
	const minutes = date.getMinutes();
	const ampm = hours >= 12 ? 'pm' : 'am';

	// Convert hours to 12-hour format
	const formattedHours = hours % 12 || 12;

	// Use template literals to construct the formatted date
	const formattedDate = `${day} ${monthAbbreviation}, ${formattedHours < 10 ? '0' : ''}${formattedHours}:${minutes < 10 ? '0' : ''}${minutes}${ampm}`;

	return formattedDate;
};

export const getDateMonthYearWithoutSuffixFromEpoch = (epochNumber?: number) => {
	if(epochNumber === null || epochNumber === undefined) return '';
	const newDateToPick = new Date(epochNumber)
	const displayDate = newDateToPick.getDate()
	const monthNames = ["Jan", "Feb", "Mar", "Apr", "May", "June",
		"July", "Aug", "Sept", "Oct", "Nov", "Dec"
	];
	const getMonthName = newDateToPick.getMonth()
	const currentYear = newDateToPick.getFullYear();
	return `${displayDate} ${monthNames[getMonthName]}, ${currentYear}`

}
